// extracted by mini-css-extract-plugin
export default {"seperator":"Layout_seperator__kBmYm","leftSide":"Layout_leftSide__Q2Wt-","rightSide":"Layout_rightSide__owP5G","container":"Layout_container__9sl+s","bar":"Layout_bar__KIAnm"};